'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:selectDate');
}

var _invoke = require('../invoke');

/**
 * 选择日期
 *
 * @memberof flight
 * @static
 * @name selectDate
 * @param {String} fromCity
 * @param {String} toCity
 * @param {String} months
 * @param {String} original
 * @return {Promise}
 * @example
 *  hbnb.flight.selectDate(
 *      fromCity,
 *      toCity,
 *      months,
 *      original
 *  ).then(function(data) {
 *      console.log(data);
 *  });
 */
module.exports = function(fromCity, toCity, months, original) {
    if (process.env.NODE_ENV !== 'production') {
        debug('original is %s', original);
        debug('from city %s', fromCity);
        debug('to city %s', toCity);
        debug('mounths is %s', months);
    }
    original = original || '';

    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'select_date', {
            original: original,
            months: months,
            fromCity: fromCity,
            toCity: toCity,
            callback: function(date) {
                resolve(date);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/flight/select-date.js
// module id = 584
// module chunks = 0